document.addEventListener("DOMContentLoaded", function () {
const params = new URLSearchParams(window.location.search);

if (params.get("contact_posted") === "true") {
    const form = document.getElementById("mayoreoForm");
    const success = document.getElementById("formSuccess");

    if (form && success) {
    form.style.display = "none";
    success.style.display = "block";
    success.hidden = false;
    success.scrollIntoView({ behavior: "smooth" });

    window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
    );
    }
}

document.querySelectorAll('a[href="#formulario"]').forEach((btn) => {
    btn.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector("#formulario");
    if (!target) return;

    const targetY = target.getBoundingClientRect().top + window.pageYOffset;
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const duration = 1100;
    let startTime = null;

    function scrollAnim(currentTime) {
        if (!startTime) startTime = currentTime;

        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const ease =
        progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        window.scrollTo(0, startY + distance * ease);

        if (timeElapsed < duration) {
        requestAnimationFrame(scrollAnim);
        }
    }

    requestAnimationFrame(scrollAnim);
    });
});
});